import { Route, redirect } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { hasPermission } from '@apply/ui';
import { isFeatureEnabled } from '@apply/store/src/user/types';
import { PermissionType, FeatureType } from '@apply/constants';
import store from '@apply/adminStore';

import ExperienceLandingPage from '../../../experience/ExperienceLandingPage';
import ExperienceRulesLanding from '../../../assessment/ExperienceRulesLanding';
import ExperienceLevelsLanding from '../../../assessment/ExperienceLevelsLanding';
import AssessmentLanding from '../../../assessment/AssessmentLanding';

function experienceLoader() {
    const { user } = store.getState();
    if (!isFeatureEnabled(user, FeatureType.Experience)) {
        return redirect('/adminreferral');
    }
    return null;
}

function experienceConfiguratorLoader() {
    const { user } = store.getState();
    if (!isFeatureEnabled(user, FeatureType.Experience) || !hasPermission(PermissionType.ExperienceConfigurator)) {
        return redirect('/adminreferral');
    }
    return null;
}

export default function ExperienceRoutes() {
    return (
        <>
            <Route
                path='/experiences/principals/*'
                loader={experienceLoader}
                element={
                    <RequireAdmin>
                        <ExperienceLandingPage />
                    </RequireAdmin>
                }
            />
            <Route
                path='/assessment/experiencerules'
                loader={experienceConfiguratorLoader}
                element={
                    <RequireAdmin>
                        <ExperienceRulesLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/assessment/experiencelevels'
                loader={experienceConfiguratorLoader}
                element={
                    <RequireAdmin>
                        <ExperienceLevelsLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/assessment'
                loader={experienceConfiguratorLoader}
                element={
                    <RequireAdmin>
                        <AssessmentLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
